import { TextField } from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";

const Hidden: FC<{ id: string; defaultValue: string | undefined }> = ({
  id,
  defaultValue,
}) => {
  
  const control = useFormContext().control;
  return (
    <Controller
      name={id}
      control={control}
      defaultValue={defaultValue ? defaultValue : ""}
      render={({ field }) => (
        <TextField {...field} type="hidden" id={id} variant="standard" />
      )}
    />
  );
};

export default Hidden;
//Hidden.whyDidYouRender = true;
